<template>
  <RouterView />
  <PwaPrompt />
  <ComposeEmailModal />
</template>

<script setup lang="ts">
import PwaPrompt from "@/components/PwaPrompt.vue";
import ComposeEmailModal from "@/components/ComposeEmailModal.vue";
</script>
